module.exports = __webpack_public_path__ + "static/5-ee511773bfb48cb96a186a29db1a4105.jpg";